import { render, staticRenderFns } from "./equipments.vue?vue&type=template&id=c11bd54c&"
import script from "./equipments.vue?vue&type=script&lang=js&"
export * from "./equipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports